import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import SkuGrid from "./SkuGrid"
import S from "./SuggestedProducts.module.scss"

const SuggestedProducts = props => {
  const data = useStaticQuery(graphql`
    {
      allContentfulCartPageRecommendations {
        edges {
          node {
            products {
              id
              name
              price
              images {
                fluid(maxWidth: 300, maxHeight: 300) {
                  ...GatsbyContentfulFluid
                }
                description
              }
              sizes {
                size
              }
            }
          }
        }
      }
    }
  `)

  const { products } = data.allContentfulCartPageRecommendations.edges[0].node
  return (
    <div className={S.suggestedproducts}>
      <hr />
      <p className={S.title}>Recommended For You</p>
      <SkuGrid Skus={products} />
    </div>
  )
}

export default SuggestedProducts
